//#region ../src/ar/chromium-camera-access-workaround.ts
/**
* Apply the Chromium camera-access tab-crash workaround.
*
* Removes `XRWebGLBinding.prototype.createProjectionLayer` (three.js r184)
* and `XRRenderState.prototype.layers` (three.js r158) so three.js falls
* back to `XRWebGLLayer`, which avoids the renderer-process crash that
* happens when both projection layers and `camera-access` are enabled.
*
* Call once during bootstrap, before any `requestSession()` call.
*
* @returns which prototype members were actually deleted on this call.
*/
function applyChromiumProjectionLayerWorkaround() {
	const result = {
		deletedCreateProjectionLayer: false,
		deletedRenderStateLayers: false
	};
	const binding = globalThis.XRWebGLBinding;
	if (binding && "createProjectionLayer" in binding.prototype) {
		delete binding.prototype.createProjectionLayer;
		result.deletedCreateProjectionLayer = true;
	}
	const renderState = globalThis.XRRenderState;
	if (renderState && "layers" in renderState.prototype) {
		delete renderState.prototype.layers;
		result.deletedRenderStateLayers = true;
	}
	return result;
}
//#endregion
export { applyChromiumProjectionLayerWorkaround };
